// extracted by mini-css-extract-plugin
export default {"card":"BookingCard_card__hf7s-","metaRow":"BookingCard_metaRow__nstwe","metaDisplay":"BookingCard_metaDisplay__mmBgH","metaContent":"BookingCard_metaContent__l2uCe"};